export default __webpack_public_path__ + "static/media/disponibilidad.0b803928.svg";